import React from 'react';
import { Button, Modal, ModalContent, ModalCloseButton } from '../common';
import { Heading, Text } from '../common/Typography';

/**
 * Lets admin choose approve-without-link or proceed to reject flow.
 */
const NoGuestPlayerModal = ({ isOpen, onClose, playerName, onApproveWithoutLink, onReject, loading = false }) => (
  <Modal isOpen={isOpen} onClose={onClose} closeOnBackdropClick={!loading}>
    <ModalContent size="small">
      <div className="flex items-start justify-between gap-2 mb-4 pr-8">
        <Heading level={3}>No guest account?</Heading>
        <ModalCloseButton onClose={onClose} className="static shrink-0" disabled={loading} />
      </div>

      <Text className="mb-6 text-sm text-text-secondary">
        {playerName} asked to link a previous guest account. Choose how to handle this.
      </Text>

      <div className="space-y-3">
        <Button
          variant="primary"
          className="w-full"
          onClick={onApproveWithoutLink}
          disabled={loading}
        >
          {loading ? 'Processing...' : 'Approve join — no account link'}
        </Button>
        <Button
          variant="outline"
          className="w-full border-danger/40 text-danger hover:bg-danger-light/40"
          onClick={onReject}
          disabled={loading}
        >
          Reject join request
        </Button>
      </div>
    </ModalContent>
  </Modal>
);

export default NoGuestPlayerModal;
